import { useCallback, useRef } from "react";

export const useCustomDebounce = (callback, delay = 100) => {
    const timerRef = useRef();

    return useCallback((...args) => {
        if (timerRef.current) {
            clearTimeout(timerRef.current);
        }

        timerRef.current = setTimeout(() => {
            callback(...args);
        }, delay);
    }, [callback, delay]);
};
